// POSTS REDUCER
export const FETCH_ALL = 'FETCH_ALL';
export const CREATE = 'CREATE';
export const UPDATE = 'UPDATE';
export const DELETE = 'DELETE';
export const LIKE = 'LIKE';
// AUTH REDUCER
export const AUTH = 'AUTH';
export const LOGOUT = 'LOGOUT';
// PUSH REDUCER
export const PUSH = 'PUSH';
export const SUBSCRIBE = 'SUBSCRIBE';
